import NoSsr from 'vue-no-ssr'

export default {
  name: 'lx-tooltip',
  components: {
    NoSsr,
  },
}
